import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { StudentAuthProvider, StudentProtected } from "./StudentAuth";
import { StudentLayout } from "./StudentLayout";
import { StudentLogin, StudentRegister, StudentForgot } from "./pages/StudentAuthPages";
import {
  StudentDashboard, StudentProfile, StudentProgram, StudentClasses, StudentMaterials,
  StudentAssignments, StudentProjects, StudentAttendance, StudentPayments,
  StudentCertificates, StudentAnnouncements, StudentSupport,
} from "./pages/StudentPages";
import PaymentHistory from "@/pages/PaymentHistory";

const G = ({ children }) => (
  <StudentProtected><StudentLayout>{children}</StudentLayout></StudentProtected>
);

export default function StudentApp() {
  return (
    <StudentAuthProvider>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="login" element={<StudentLogin />} />
        <Route path="register" element={<StudentRegister />} />
        <Route path="forgot-password" element={<StudentForgot />} />
        <Route path="payment-history" element={<PaymentHistory />} />

        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<G><StudentDashboard /></G>} />
        <Route path="profile" element={<G><StudentProfile /></G>} />
        <Route path="program" element={<G><StudentProgram /></G>} />
        <Route path="classes" element={<G><StudentClasses /></G>} />
        <Route path="materials" element={<G><StudentMaterials /></G>} />
        <Route path="assignments" element={<G><StudentAssignments /></G>} />
        <Route path="projects" element={<G><StudentProjects /></G>} />
        <Route path="attendance" element={<G><StudentAttendance /></G>} />
        <Route path="payments" element={<G><StudentPayments /></G>} />
        <Route path="certificates" element={<G><StudentCertificates /></G>} />
        <Route path="announcements" element={<G><StudentAnnouncements /></G>} />
        <Route path="support" element={<G><StudentSupport /></G>} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </StudentAuthProvider>
  );
}
